import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { H4 } from "@fastly/consistently"

import RecentlyViewed from "~components/RecentlyViewed/RecentlyViewed"

import NavData from "~data/nav_security.yml"

import { Yaml2Menu } from "./side-menu"
import { SideMenu, SideMenuItem, SideMenuTriggerLink } from "@fastly/consistently-vanilla"
import FrontmatterPageContext from "../../context/FakePageContext"

export const SideMenuSecurityEN = () => {
  const frontmatter = React.useContext(FrontmatterPageContext)
  const data = useStaticQuery(graphql`
    query HeaderQuerySecurityEN {
      primarys: allMdx(filter: { fileAbsolutePath: { regex: "//_en_security_primary/" } }) {
        nodes {
          frontmatter {
            cat_id
            section_name
            nav_title
          }
        }
      }
      secondarys: allMdx(
        filter: { fileAbsolutePath: { regex: "//_en_security_secondary/" } }
        sort: { fields: slug }
      ) {
        nodes {
          frontmatter {
            crumb
            name
            nav_title
          }
        }
      }
      guides: allMdx(
        filter: { fileAbsolutePath: { regex: "//_en_security//" }, frontmatter: { published: { ne: false } } }
        sort: { fields: [frontmatter___order, slug], order: [ASC, ASC] }
      ) {
        group(field: frontmatter___secondary_nav) {
          fieldValue
          nodes {
            fileAbsolutePath
            slug
            frontmatter {
              header
              order
              primary_nav
              secondary_nav
              unlisted
              nav_title
            }
          }
        }
      }
      orphans: allMdx(
        filter: { fileAbsolutePath: { regex: "//_en_security//" }, frontmatter: { published: { ne: false }, orphan: { eq: true } } }
        sort: { fields: [frontmatter___order, slug], order: [ASC, ASC] }
      ) {
        group(field: frontmatter___primary_nav) {
          fieldValue
          nodes {
            fileAbsolutePath
            slug
            frontmatter {
              header
              order
              primary_nav
              secondary_nav
              unlisted
              nav_title
            }
          }
        }
      }
    }
  `)

  const slug_collection = "_en_security/"
  const link_prefix = "/en/guides/"

  const menu = Yaml2Menu(data, NavData, slug_collection, link_prefix)
  const openedMenu = frontmatter.cat_id
    || frontmatter.primary_nav

  return (
    <SideMenu defaultValue={[openedMenu]}>
      <H4 my="0">{"Security"}</H4><br/>
      <SideMenuItem value={"Next-Gen WAF"}>
        <SideMenuTriggerLink href={`/en/ngwaf`} style={{ paddingLeft: 24 }}>
          {"Next-Gen WAF"}
        </SideMenuTriggerLink>
      </SideMenuItem>
      {menu}
      <RecentlyViewed />
    </SideMenu>
  )
}